import ClientRouter from './clientRouter';
import { loadComponents } from '../shared/resolvers';
import { pageState, viewState } from '../shared/page';
import App from '../shared/App.svelte';
export async function createClient(onError) {
    const router = new ClientRouter();
    const page = window.__preloadedStores__['page'];
    await loadComponents(page.dependencies);
    let procesing = false;
    let controller = new AbortController();
    let signal = controller.signal;
    router.init(async (toGo) => {
        if (procesing) {
            controller.abort();
            controller = new AbortController();
            signal = controller.signal;
        }
        try {
            procesing = true;
            const u = new URL(toGo.href);
            u.searchParams.append('json', 'true');
            const newPageResponse = await fetch(u, {
                headers: {
                    'content-type': 'application/json'
                },
                credentials: 'include',
                signal: signal
            });
            if (newPageResponse.redirected) {
                history.replaceState(null, '', newPageResponse.url);
            }
            const data = (await newPageResponse.json());
            pageState.set(data.page);
            await loadComponents(data.page.dependencies);
            viewState.set(data.view);
            procesing = false;
        }
        catch (error) {
            if (onError) {
                onError(error);
            }
        }
    });
    new App({
        target: document.querySelector('#App'),
        hydrate: true
    });
    // clean up ssr css
    const stateScript = document.querySelector('#ssr-state');
    if (stateScript)
        stateScript.remove();
    if (page.path === '/_preview' && page.query.viewName) {
        await import('./preview');
    }
}
